import React from 'react';
import { BiError } from 'react-icons/bi';
import { Link } from 'react-router-dom';
const NotFoundPage = () => {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-5 bg-zinc-900">
      <BiError className="text-6xl" />
      <p className="text-lg text-zinc-200">Page not found</p>
      <Link to="/" className="text-lg text-zinc-200">
        Home
      </Link>
    </div>
  );
};

export default NotFoundPage;
